export const MATTER_INSURANCE_TYPE_OPTIONS = [
  "Auto",
  "Home",
  "Health",
] as const;

export const MATTER_INSURANCE_CATEGORY_OPTIONS = [
  "Medicaid",
  "Medicare",
  "Private",
];

export const MATTER_INSURANCE_LIABILITY_OPTIONS = [
  "Accepted",
  "Partially Accepted",
  "Denied",
  "Pending",
] as const;

export const INSURANCE_TYPES = [
  "Auto",
  "Health",
  "Property",
  "Commercial",
  "Umbrella",
  "Government",
  "Excess",
  "Other / Specialty",
] as const;

export type InsuranceType = (typeof INSURANCE_TYPES)[number];

const insuranceTypeSet: ReadonlySet<string> = new Set(INSURANCE_TYPES);

export function isInsuranceType(value: string): value is InsuranceType {
  return insuranceTypeSet.has(value);
}

export const CATEGORIES_BY_INSURANCE_TYPE = {
  Auto: [],
  Health: [
    "ERISA",
    "Marketplace / ACA plan",
    "Medi-Cal",
    "Medicare",
    "Private",
    "TRICARE / Military",
    "Other",
  ],
  Property: [
    "Homeowner's liability",
    "Renter's Insurance",
    "Landlord liability",
    "Premises liability",
    "Other",
  ],
  Commercial: [
    "CGL (Commercial General Liability)",
    "Employer Auto (Commercial Auto)",
    "Business Owner's Policy (BOP)",
    "Workers' Compensation",
    "Other",
  ],
  Umbrella: ["Personal Umbrella", "Commercial Umbrella", "Other"],
  Government: ["City / County / State coverage", "Federal", "Other"],
  Excess: [],
  "Other / Specialty": [
    "Malpractice",
    "School District",
    "Specialty Riders",
    "Other",
  ],
} as const satisfies Record<InsuranceType, readonly string[]>;

/** Alphabetical menu order for “Add insurance” type picker (matches product copy). */
export const ADD_INSURANCE_TYPE_MENU_ORDER = [
  "Auto",
  "Commercial",
  "Excess",
  "Government",
  "Health",
  "Other / Specialty",
  "Property",
  "Umbrella",
] as const satisfies readonly InsuranceType[];

/** Dropdown label, e.g. “Auto Insurance”, “Other Insurance”. */
export function formatAddInsuranceTypeMenuLabel(type: InsuranceType): string {
  const base = type === "Other / Specialty" ? "Other" : type;
  return `${base} Insurance`;
}
